<template>
  <v-container fluid fill-height pa-0 ma-0 v-show="!status.loading">
    <v-layout row wrap pa-0 ma-0>
      <v-flex md1 lg1 xl2 d-xs-none></v-flex>
      <v-flex md4 lg4 xl3 xs12 pt-6 style="flex-direction: column; display: flex">
        <v-row class="pa-0 ma-0">
        <v-col class="pa-0 ma-0">
          <div class="mb-6 px-16 px-sm-16 px-md-0 pr-md-16">
            <img :src="(branding.use_logo_url) ? branding.brand_logo_url : branding.brand_logo_base64" style="max-width:240px; max-height: 150px;"  alt="Logo"/>
          </div>
        </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col class="pa-0 ma-0">
          <!-- The product name, the same in every language, so it is not translated. -->
          <div class="text-h4 primary--text px-16 px-sm-16 px-md-0 pr-md-16 brand-font font-weight-light">
            RSS Presence<br/>
            by Telediagnosis
          </div>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-0">
          <v-col class="pa-0 ma-0">
        <div class="px-16 px-sm-16 px-md-0 pr-md-16 mt-8" style="max-width: 500px;">
          <div v-if="!component">
            <UserLoginForm v-if="!twoFactor.enabled"/>
            <UserTwoFactorForm v-if="twoFactor.enabled && config.twoFactorEnabled && !twoFactor.completed"></UserTwoFactorForm>
            <UserTermsOfServiceForm v-if="config.checkTosEnabled && twoFactor.completed && !isTosAccepted"></UserTermsOfServiceForm>
          </div>
          <div class="mt-16 mb-16" v-else>
            <UserResetPasswordForm v-if="component === 'UserResetPasswordForm'"/>
          </div>
        </div>
          </v-col>
        </v-row>
        <div class="text-caption text--secondary mb-4 mt-2 px-16 px-sm-16 px-md-0 pr-md-16" style="align-self: flex-end; width: 100%;">
          &copy; {{$_t('Telediagnosis Sp. z o.o. All Rights Reserved.')}}
        </div>
      </v-flex>
      <v-flex d-xs-none md7 style="background-size: cover; background-image: url('/img/login-background.webp'); background-position: center" />
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import config from '@/config';
import UserLoginForm from "@/components/Login/User/UserLoginForm";
import UserTwoFactorForm from "@/components/Login/User/UserTwoFactorForm";
import UserTermsOfServiceForm from "@/components/Login/User/UserTermsOfServiceForm";
import UserResetPasswordForm from "@/components/Login/User/UserResetPasswordForm";

export default {
  components: {
    UserLoginForm,
    UserTwoFactorForm,
    UserTermsOfServiceForm,
    UserResetPasswordForm
  },
  props: ['component'],
  data () {
    return {
      config: {'logoFull': '#', 'background': false},
      locale: null,
      locales: [
        {id: 'pl', name: 'Polski'},
        {id: 'en', name: 'English'}
      ]
    }
  },
  computed: {
    ...mapState('account', ['status', 'user', 'redirectLink', 'isTosAccepted', 'twoFactor']),
    ...mapState('brand', ['branding']),
    style() {
      if (this.config.background) {
        return {
          'background-size': 'cover',
          'background-image': 'url("' + this.config.background + '")'
        }
      }
      return ''
    }
  },
  created () {
    if(this.status.loggedIn) {
      this.$router.push({ path: '/' });
    }
  },
  methods: {
    ...mapActions('brand', ['getBranding']),
    ...mapActions('account', ['loading'])
  },
  mounted: function () {
    this.config = config
  }
}
</script>

